import { memo } from 'react';
import Markdown from 'react-markdown';
import { EditActionButtons } from '../presentation/EditActionButtons';
import styles from './style/SegmentPersona.module.css';

const DEFAULT_PLACEHOLDER = `Paste or type your persona details here...

Example:

- Voice: Professional, friendly, and supportive
- Behaviors: Responds with empathy, provides actionable advice
- Data: Use customer purchase history and preferences`;

type PersonaReadOnlyProps = {
  /** The persona text to display (renders as markdown) */
  persona: string | null | undefined;
  /** Placeholder text to show when persona is empty (renders as markdown) */
  placeholder?: string;
  /** Callback when edit button is clicked */
  onEdit: () => void;
  /** Whether whitelabel theming is enabled (optional) */
  whitelabelEnabled?: boolean;
  /** Primary color for whitelabel theming (optional) */
  primaryColor?: string;
};

/**
 * PersonaReadOnly displays persona text as rendered markdown with an edit button.
 * This is a purely presentational component with no state management.
 */
const PersonaReadOnlyComponent = ({
  persona,
  placeholder = DEFAULT_PLACEHOLDER,
  onEdit,
  whitelabelEnabled,
  primaryColor,
}: PersonaReadOnlyProps) => {
  return (
    <div className={styles['persona-display-container']}>
      <div className={styles['persona-content']}>
        {persona ? (
          <Markdown>{persona}</Markdown>
        ) : (
          <div className={styles.placeholder}>
            <Markdown>{placeholder}</Markdown>
          </div>
        )}
      </div>
      <EditActionButtons
        isEditing={false}
        onEdit={onEdit}
        onSave={NOOP}
        onCancel={NOOP}
        themedColor={whitelabelEnabled && primaryColor ? primaryColor : undefined}
      />
    </div>
  );
};

// EditActionButtons' onSave/onCancel are only ever invoked while isEditing — never true here.
function NOOP() {
  /* no-op */
}

export const PersonaReadOnly = memo(PersonaReadOnlyComponent);
